export const getQueryString = (queryParams) => {
  if (!queryParams) {
    return '';
  }

  const query = Object.keys(queryParams)
    .filter((key) => {
      const value = queryParams[key];
      return value !== undefined && value !== null && value !== '';
    })
    .map((key) => {
      const value = queryParams[key];
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .join('&');

  return query ? `?${query}` : '';
};
// FOR PAGINATION
export const getOffsetLimitFromPagination = ({ currentPage, pageSize }) => ({
  limit: pageSize,
  offset: (currentPage - 1) * pageSize
});
export const getOffsetLimitFromPaginationCampaigns = ({ currentPage, pageSize }) => ({ per_page: pageSize, page: currentPage });
export const getOffsetLimitFromPaginationLists = ({ currentPage, pageSize }) => ({ per_page: pageSize, page: currentPage });
